import React, {
  useContext,
  useEffect,
} from 'react';
import { SelectionTreeContext } from '../context';

import { buildMap, filterTreeItems } from '../utils';
import { DataSourceProps } from '../types';

export const ClientDataSource: React.FC<DataSourceProps> = ({ treeItems, customFilter }) => {
  const {
    searchQuery,
    updateItemsMap,
    updateItems,
  } = useContext(SelectionTreeContext);

  useEffect(() => {
    const itemsMap = buildMap(treeItems);
    const filteredTreeItems = filterTreeItems(treeItems, itemsMap, searchQuery, customFilter);

    updateItemsMap(itemsMap);
    updateItems(filteredTreeItems);
  }, [treeItems, searchQuery, customFilter, updateItems]);

  return null;
};
